import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

// middlewares
import checkIsUserAllowedToSeeModule from "@/router/middlewares/checkIsUserAllowedToSeeModule";

// module routes
import routes from "@/router/modules";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: routes,
});

import { handleTranslationForNextModule } from "@/services/localization-service";
import routerWindowService from '@/router/services/router-window-service';
import registryService from '@/router/services/registry-service';
import preloadService from '@/router/services/preload-service';
import toDecorator from '@/router/services/to-decorator';
import WorkAuthentication from "@/services/authentication_services/WorkAuthentication";
import { useAvailableWorkflowActionCheck } from '@/composables/AvailableWorkflowActionCheck';
import excludePaths from './excludePaths';
import moduleRegistry from '@/configuration/module-registry';

router.beforeEach(async (to, from, next) => {

    if (excludePaths.exclude_authentication_paths.some(path => to.path.startsWith(path))) {
        handleTranslationForNextModule(to);
        return next();
    }

    if ((!WorkAuthentication.isAuthenticated() || WorkAuthentication.isAuthenticatedForExtern()) && to.name !== "LoginView") {
        WorkAuthentication.terminateAuthentication();
        return next(`/login?to=${to.fullPath}`);
    }

    const isUserAllowedToSeeModule = checkIsUserAllowedToSeeModule(to);
    if (isUserAllowedToSeeModule === false) { return next('/pageNotFound'); }

    if (to.path.includes('/workflow-action/')) {
        // check if requested workflowaction is available for project. Redirect if not
        let redirect = await useAvailableWorkflowActionCheck(to.path);
        if (redirect !== undefined) {
            return next(redirect);
        }
    }

    handleTranslationForNextModule(to);

    const currentModule = store.state['activeModule'];
    const currentModuleIsAWindow = currentModule.isWindow !== undefined && currentModule.isWindow === true;

    if (currentModuleIsAWindow) {
        routerWindowService.handleRedirectInWindow(from);
    }

    await registryService.loadRegistries(to);
    await preloadService.loadPreloads(to);

    const withReplace = await toDecorator.decorateTo(to);
    if (withReplace) { next({ ...to, replace: true }) }

    const moduleGroup = moduleRegistry.tree.find(module =>
        module.children.find(item => item.id === to.meta.moduleId)
    );
    if (moduleGroup) store.dispatch('sidebarDrawer/setSelectedGroup', moduleGroup.id);

    const ignoreNextRoutingObject = store.getters['routingHistory/getIgnoreNextRoutingObject'];
    if (ignoreNextRoutingObject !== true)
        store.dispatch('tableStore/deleteAllTablesWithoutReference');

    next();
});

router.afterEach(async (to, from) => {
    const ignoreNextRoutingObject = store.getters['routingHistory/getIgnoreNextRoutingObject'];
    if (ignoreNextRoutingObject === true) {
        return store.dispatch('routingHistory/dontIgnoreNextRoutingObject');
    }

    store.dispatch('routingHistory/handleNewRoutingObject', { to, from });
    store.dispatch('mobileWrapperTasks/removeAllExpiredTasks');
});

export default router;
